import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  errorFallbackMessage: {
    id: 'errorFallback.errorFallbackMessage',
    defaultMessage: 'Odottamaton virhe on tapahtunut. Virhe on raportoitu ja pyrimme korjaamaan sen mahdollisimman pian.',
  },
  retry: {
    id: 'errorFallback.retry',
    defaultMessage: 'Yritä uudelleen',
  },
})
